import { render } from "./TabsContent.vue?vue&type=template&id=44e508ea&scoped=true"
import script from "./TabsContent.vue?vue&type=script&lang=js"
export * from "./TabsContent.vue?vue&type=script&lang=js"

import "./TabsContent.vue?vue&type=style&index=0&id=44e508ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e508ea"]])

export default __exports__